import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  Operation,
  setChangeSupplierDialog,
} from "../../../../../app/slices/operationSlice";
import { Controller, useForm } from "react-hook-form";
import { SelectSupplier } from "../../../../../components/Selectors/SelectSupplier";
import { HiOutlineArrowsRightLeft, HiOutlineTruck } from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../../components/FormDialog";

const ChangeSupplierForm = (props) => {
  const dispatch = useDispatch();
  const _ChangeSupplier = useSelector(
    (state) => state.operation.changeSupplier
  );
  const _SearchBody = useSelector((state) => state.operation.searchBody);
  const _Supplier = useSelector((state) => state.supplier.suppliersList.data);

  const { control, handleSubmit, setValue } = useForm({
    defaultValues: {},
  });

  const onSubmit = (data) => {
    data.operation_id = _ChangeSupplier.form?.operation_id;
    dispatch(Operation.changeSupplier(data, _SearchBody));
  };

  const handleDialog = () => {
    dispatch(setChangeSupplierDialog(null));
  };

  return (
    <FormDialog
      open={_ChangeSupplier.dialog}
      onClose={handleDialog}
      icon={<HiOutlineArrowsRightLeft />}
      title={"تغيير المورد"}
      subtitle="اختر المورد الجديد ثم احفظ التغييرات"
      onSubmit={handleSubmit(onSubmit)}
    >
      <SectionCard icon={<HiOutlineTruck />} title="المورد">
        <Grid item xs={12}>
          <Controller
            name="supplier_id"
            control={control}
            render={({ field }) => (
              <SelectSupplier
                required
                onChange={(e, newValue) => {
                  setValue("supplier_id", newValue ? newValue.id : null);
                }}
                value={
                  _Supplier.filter((x) => x.id === field.value)[0] ?? null
                }
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default ChangeSupplierForm;
